



































import Vue from 'vue';
import ComponentUsageExample from './ComponentUsageExample.vue';
import ArrowLeftIcon from '@/assets/arrow-left.svg';

export default Vue.extend({
  name: 'ComponentPage',
  components: {
    ComponentUsageExample,
    ArrowLeftIcon,
  },
  props: {
    title: { type: String, required: true },
    enlargedExampleGap: Boolean,
  },
});
